import React from "react";
import PropTypes from "prop-types";

import styles from "./Footer.module.css";

const UIFooter = ({ className, children, ...rest }) => {
  return (
    <div {...rest} className={`${styles.footer} ${className}`}>
      {children}
    </div>
  );
};

UIFooter.propTypes = {
  className: PropTypes.string
};

export default UIFooter;
